/**
 * The new red button with icon support
 */

import React from 'react';
import Icon from '@material-ui/core/Icon';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './OutlineButton.module.scss';
import Aux from '../../../layout/Aux';
import { computeOutlineButtonAriaLabel } from './OutlineButton.utils';

const { container, buttonText, loadingIconStyle } = styles;

const OutlineButton = ({
  onClick,
  children,
  icon,
  className,
  disabled,
  isLoading,
  testId,
  buttonLabel,
  ...rest
}) => {
  const containerClassNames = [];

  // Container class names
  containerClassNames.push(container);
  if (className) {
    containerClassNames.push(className);
  }

  // Button text class names
  const buttonTextClassNames = [];
  if (icon) {
    buttonTextClassNames.push(buttonText);
  }
  const computedAriaLabel = computeOutlineButtonAriaLabel(children, buttonLabel);

  return (
    <button
      aria-label={computedAriaLabel}
      type="button"
      className={containerClassNames.join(' ')}
      onClick={onClick}
      disabled={isLoading || disabled}
      data-testid={testId}
      {...rest}
    >
      {icon && <Icon aria-hidden="true">{icon}</Icon>}
      <span className={buttonTextClassNames.join(' ')}>
        {isLoading && (
          <Aux>
            <LoadingOutlined
              className={loadingIconStyle}
              style={{ fontSize: 14, margin: 0 }}
              spin
              aria-hidden="true"
              data-testid="outline-button-loader"
            />
            &nbsp;
          </Aux>
        )}
        {children}
      </span>
    </button>
  );
};

export default OutlineButton;
